let moreApi = function () {
  if (process.env.NODE_ENV === 'development') {
    return '/more_api'
  } else {
    return ''
  }
}
export default {
  /**
   * 登陆流程接口
   */
  securityCode: moreApi() + '/user/login-code', // 验证码获取
  login: moreApi() + '/user/login', // 用户登陆
  getProducts: moreApi() + '/products', // 根据URL获取产品products

  /**
   * 通讯录接口
   */
  addressGroup (orgId) { // 获取通讯录分组信息
    return moreApi() + 'organizations/' + orgId + '/sub_organizations'
  },
  addressPersons (orgId) { // 获取分组内人员列表
    return moreApi() + 'organizations/' + orgId + '/persons'
  },
  addressContact (orgId, personId) { // 获取联系信息
    return moreApi() + 'organizations/' + orgId + '/persons/' + personId
  },
  searchPerson (orgId, searchData) { // 人员搜索接口
    return moreApi() + 'organizations/' + orgId + '/persons/search?search=' + searchData
  }
}



// WEBPACK FOOTER //
// ./src/tools/api.js